import { Link } from 'react-router-dom';
import cx from 'classnames';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import styles from './GuideAuthorCard.module.scss';

type GuideAuthorCardProps = {
  ctaLabel?: string;
  ctaLink: string;
  description?: string;
  image?: string;
  jobTitle?: string;
  size?: 'small';
  title: string;
};

export const GuideAuthorCard: React.FC<GuideAuthorCardProps> = ({
  ctaLabel = 'Read more',
  ctaLink,
  description,
  image,
  jobTitle,
  size,
  title,
}) => (
  <div className={styles.wrapper}>
    {image && (
      <div className={styles.image}>
        <img
          alt={title}
          height="150"
          loading="lazy"
          src={image}
          width="200"
        />
      </div>
    )}
    <div className={styles.info}>
      <h3 className={cx(styles.name, {
        [styles.small]: size === 'small',
      })}>
        <Hyperlink
          as={Link}
          className={styles.stretchedLink}
          label={title}
          to={ctaLink}
          underline={false}
        />
      </h3>
      {jobTitle && (
        <span className={styles.jobTitle}>{jobTitle}</span>
      )}
      {description && (
        <span
          dangerouslySetInnerHTML={{ __html: description }}
          className={styles.description}
        />
      )}
      <span className={styles.cta}>
        {ctaLabel}
      </span>
    </div>
  </div>
);
